module.exports = __webpack_public_path__ + "static/media/20210212_220554_459_IMG_2219.74ffd9af.jpg";